<template>
  <div>
    <SectionTitle :has-line="true" content="Necesidades" />
    <div class="container-fluid my-2">
      <div class="row">
        <div class="col-12">
          <CustomDropDown
            v-if="showNecessitiesCatalogue"
            id="n-dd"
            v-model="selectedGrade"
            :options="gradeOptions"
            label="Grado:"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione el Grado"
            class="mb-4 w-25 bold-label"
            :disabled="ReadOnly"
          />
          <MultiSelectionPicker
            v-if="!ReadOnly"
            maxlength="1500"
            :isbgwhite="true"
            :enable-bg-alternate="true"
            :all-items="availableNecessities"
            :selected-items="currentSelection"
            item-type-name="Necesidad"
            :allow-item-list-editing="
              selectedGrade?.id && hasNecessityEdition && !ReadOnly
            "
            :modify-removes-item="true"
            :column-count="1"
            :disabled="ReadOnly"
            @itemDeleted="deleteNecessity"
            @itemAdded="addNewNecessity"
            @itemModified="editNecessity"
          />
        </div>
      </div>
      <div v-if="!ReadOnly" class="row mt-3">
        <div class="col-12">
          <Error
            is-alert-mode
            message="Puede seleccionar una(1) o más necesidades. Selección múltiple."
          />
        </div>
      </div>
      <div v-if="!ReadOnly" class="row mt-3">
        <div class="col-12">
          <Error
            v-if="hasError || (isSubmitted && hasInnerError)"
            message="Este campo debe ser completado."
          />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <CustomChipsGroup
            title="Necesidades Seleccionadas"
            :no-wrap="true"
            :selected-items="wrappedSelection"
            object-text="name"
            :disabled="ReadOnly"
            :class="{ 'custom-chips-group': ReadOnly }"
            @itemMarkedForDeletion="removeNecessitySelection"
          />
        </div>
      </div>
    </div>

    <div
      v-if="!ReadOnly"
      class="mt-3 d-flex justify-content-end align-items-center"
    >
      <ActionButton i="fas fa-save" variant="success m-2" @click="save">
        Guardar
      </ActionButton>
    </div>
  </div>
</template>

<script>
import MultiSelectionPicker from "@/components/common/MultiSelectionPicker";
import CustomChipsGroup from "@/components/common/CustomChipsGroup";
import alert from "@/mixin/alert.mixin";
import ActionButton from "@/components/common/ActionButton";
import Error from "@/components/common/Error";
import CustomDropDown from "custom-drop-down";
import { SectionTitle } from "@/components/pei/shared";
import PeiApi from "./service";

import { modulesName } from "@/modules";
import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapActions, mapState } = createNamespacedHelpers(
  modulesName.programServiceModuleName
);

export default {
  name: "NecessitiesSelection",
  mixins: [alert],
  components: {
    MultiSelectionPicker,
    CustomDropDown,
    CustomChipsGroup,
    ActionButton,
    SectionTitle,
    Error
  },
  props: {
    programServiceAreaId: {
      default: 0
    },
    areaId: {
      default: 0
    },
    selectedPeiId: {
      default: 0
    },
    pei: {
      type: Object,
      default: () => {}
    },
    hasError: {
      type: Boolean,
      default: false
    },
    ReadOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedGrade: null,
      isSubmitted: false,
      currentSelection: [],
      deletedNecessities: [],
      availableNecessities: [],
      idCounter: 0
    };
  },
  computed: {
    ...mapState(['createdGoals', 'selectedNecessities']),
    ...mapGetters([
      "showNecessitiesCatalogue",
      "hasNecessityEdition",
      "necessityOptions",
      "gradeOptions",
      "resource",
      "defaultGrade",
      "isDiscipline"
    ]),
    hasInnerError() {
      return this.currentSelection.length <= 0;
    },
    wrappedSelection() {
      return this.currentSelection.map(x => ({ ...x, }));
    }
  },
  methods: {
    ...mapActions([
      "fetchGoalsTabInfo",
      "fetchNecessityTabInfo",
      "fetchStrengthNecessityTabInfo"
    ]),
    removeNecessitySelection(payload) {
      let editedItemIndex = this.currentSelection.findIndex(
        e => e.id === payload?.id
      );
      this.currentSelection.splice(editedItemIndex, 1);
    },
    editNecessity(item, index) {
      if (item.id > 0) {
        item.isDirty = true;
        (item.value = this.selectedGrade?.id?.toString()),
          (item.grade = this.selectedGrade?.name);
      }

      this.availableNecessities.splice(index, 0, item);
    },
    async deleteNecessity(item) {
      let alertResponse = await this.ShowCancelModal(
        "Atención",
        `¿Esta seguro que desea eliminar la necesidad ${item.name}"?`,
        "Aceptar",
        "Cancelar"
      );

      if (!alertResponse) return;

      let removedItemIndex = this.availableNecessities.findIndex(
        e => e.id === item.id
      );
      this.availableNecessities.splice(removedItemIndex, 1);
      this.deletedNecessities.push(item);
    },
    addNewNecessity(itemText) {
      this.availableNecessities.push({
        id: (this.idCounter += -1),
        name: itemText,
        value: this.selectedGrade?.id?.toString(),
        grade: this.selectedGrade?.name
      });
    },
    async save() {
      try {
        this.isSubmitted = true;

        if (this.hasInnerError) return false;

        let dto = {
          areaId: parseInt(this.areaId, 10),
          peiId: this.selectedPeiId.toString(),
          programServiceAreaId: parseInt(this.programServiceAreaId, 10),
          selectedNecessities: this.currentSelection,
          availableNecessities: this.availableNecessities,
          deletedNecessities: this.deletedNecessities
        };

        await PeiApi.SaveNecessityInfo(dto);

        this.ShowToast(
          this.resource("R03200110"),
          this.resource("R03200109"),
          "success"
        );

        if (!this.hasInnerError) {
          this.isSubmitted = false;
        }

        this.deletedNecessities = [];
        this.$emit('pending-changes', false);

        await this.fetchGoalsTabInfo();
        await this.fetchNecessityTabInfo(this.selectedGrade?.id);
        await this.fetchStrengthNecessityTabInfo(this.selectedGrade?.id);

        return true;
      } catch (err) {
        this.ShowToast(
          'Error',
          err.response.data.message ?? this.resource("R03200108"),
          "error"
        );
      }
    }
  },
  watch: {
    selectedGrade: {
      deep: true,
      handler(newValue) {
        this.fetchNecessityTabInfo(newValue?.id);
      }
    },
    necessityOptions(newValue) {
      this.availableNecessities = [...newValue];
    },
    selectedNecessities(newValue) {
      const skillNames = this.createdGoals
        .map(x => x.strenghtsAndNecessities.map(y => y.name.trim()))
        .flat();

      this.currentSelection = [...newValue.map(x => ({
          ...x,
          disabled: skillNames.includes(x.name.trim())
      }))];
    },
    defaultGrade: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (!newValue?.id) return;

        this.selectedGrade = { ...newValue };
      }
    },
    currentSelection: {
      deep: true,
      immediate: false,
      handler(newValue) {
        if (this.selectedNecessities.length != newValue.length) {
          this.$emit('pending-changes', true);
        }
      }
    },
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/variables/_colors.scss";
.actions {
  display: flex;
  justify-content: flex-end;
}
::v-deep .bold-label > .data-name {
  font-weight: 700;
  color: map-get($colors, "black") !important;
}

::v-deep .custom-chips-group {
  & div.mt-3 {
    margin-top: 0% !important;
  }
  & .chips-container {
    margin-top: 0% !important;
    padding-top: 0% !important;
  }
}
</style>
